import React from 'react';
import { BarChart3 } from 'lucide-react';

/**
 * ManagerAnalytics Component
 * Performance analytics across the manager's property portfolio
 */
const ManagerAnalytics = () => {
    return (
        <div className="min-h-screen bg-karibu-100 pt-20 pb-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mb-8">
                    <h1 className="font-display text-3xl font-bold text-soil-900">Analytics</h1>
                    <p className="mt-2 text-soil-600">
                        Track views, inquiries, and performance across your listings
                    </p>
                </div>
                <div className="text-center py-12 bg-white rounded-lg shadow-sm border border-soil-100">
                    <BarChart3 className="mx-auto h-12 w-12 text-soil-400 mb-4" />
                    <h3 className="font-display text-lg font-medium text-soil-900 mb-2">Coming Soon</h3>
                    <p className="text-soil-600">This feature is under development</p>
                </div>
            </div>
        </div>
    );
};

export default ManagerAnalytics;
